"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerQuestionModal = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var validation_1 = require("utils/helpers/validation");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('AnswerQuestionModal'), (0, recompose_1.withState)('answer', 'setAnswer', ''), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (this.props.isOpen === false &&
            this.props.isOpen !== prevProps.isOpen) {
            this.props.setAnswer('');
        }
        if (this.props.isOpen === true &&
            this.props.isOpen !== prevProps.isOpen &&
            this.props.questions.length === 1) {
            this.props.setAnswer(this.props.questions[0].answer || '');
        }
    }
}), recompose_1.pure);
exports.AnswerQuestionModal = enhance(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.isOpen, className: 'bid-questions-modal' },
    React.createElement(sok_ui_1.Header, { onClose: props.onClose }, (0, translation_1.getLocalization)("bid/questionsAndAnswers/".concat(props.questions.length <= 1 ? 'answer' : 'answerMultiple', "/header"))),
    React.createElement(sok_ui_1.Container, null,
        React.createElement(sok_ui_1.RequestStatusBox, { status: props.status, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILED'] },
            React.createElement("span", null, (0, translation_1.getLocalization)('bid/questionsAndAnswers/status/saving')),
            React.createElement("span", null, (0, translation_1.getLocalization)('bid/questionsAndAnswers/status/saved')),
            React.createElement("span", null, (0, translation_1.getLocalization)('bid/questionsAndAnswers/status/failed'))),
        props.questions.length === 1 && (React.createElement("div", { className: "bid-question-container" },
            React.createElement("label", { htmlFor: 'bid-question' }, (0, translation_1.getLocalization)("bid/questionsAndAnswers/question")),
            React.createElement("div", null, props.questions[0].question))),
        React.createElement("div", { className: "bid-answer-container bid-answer-container-small" },
            React.createElement("label", { htmlFor: 'bid-answer' }, (0, translation_1.getLocalization)("bid/questionsAndAnswers/answer")),
            React.createElement(sok_ui_1.TextInput, { id: 'bid-answer', type: 'textarea', value: props.answer, onChange: function (e) { return props.setAnswer(e.target.value); } }),
            (0, validation_1.getError)("answer", props.errors))),
    React.createElement(sok_ui_1.Footer, null,
        React.createElement(sok_ui_1.Button, { color: 'green', disabled: props.status === 'FETCHING', onClick: function () {
                return props.onSave(props.questions.map(function (x) { return (__assign(__assign({}, x), { answer: props.answer })); }));
            } }, (0, translation_1.getLocalization)("buttons/save")),
        React.createElement(sok_ui_1.Button, { color: 'dark-gray', onClick: props.onClose }, (0, translation_1.getLocalization)("buttons/close"))))); });
